document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const isMobile = window.matchMedia('(max-width: 989px)').matches;
    if (!isMobile) return;

    const link = event.target.closest('a');
    if (!link) return;

    const menu = link.closest('.menu-drawer, .mobile-menu, .t4s-drawer-menu, .t4s-mb-nav, nav');
    if (!menu) return;

    const item = link.closest('li');
    if (!item) return;

    const toggle = item.querySelector(
      ':scope > button, :scope > .t4s-mb-nav__icon, :scope > .t4s-menu-item-toggle, :scope > .menu-toggle, :scope > .open-child'
    );

    const submenu = item.querySelector(
      ':scope > ul, :scope > .submenu, :scope > .sub-menu, :scope > .t4s-sub-menu, :scope > .menu-drawer__submenu'
    );

    if (!toggle && !submenu) return;

    event.preventDefault();
    event.stopPropagation();

    if (toggle) {
      toggle.click();
      return;
    }

    item.classList.toggle('is-open');

    if (submenu) {
      const isOpen = submenu.style.display === 'block';
      submenu.style.display = isOpen ? 'none' : 'block';
    }
  });
});